import useMediaQuery from "@mui/material/useMediaQuery";

// True on devices with a real mouse pointer. Hover-only hints (e.g. the collapsed sidebar's
// labels) use it to stay hidden on tablets, where a tap would flash them while navigating.
export default function useCanHover() {
  return useMediaQuery("(hover: hover) and (pointer: fine)");
}
